module.exports = __webpack_public_path__ + "static/media/PaymentGiftCard.ad16e6c2.png";